<template>
  <div class="pages">
    <div class="pages-title">Android APP 第三方SDK列表</div>
  <div style="color: #3D3833;text-indent: 2em;margin-bottom: 16px;">为保障小蜂蜂闪运的运行和功能，我们可能会接入软件开发包("SDK"）以实现必要的功能和服务目的。为了您的个人信息安全，对于接入的SDK，我们会进行严格的审核。以下列表包括了我们在小蜂蜂闪运 APP Android平台可能接入的SDK。其中的"隐私政策链接"栏目提供了相应第三方个人信息处理政策。提请您注意，由于版本迭代、运营变化等原因，第三方个人信息处理政策可能会发生变化。</div>
  <div class="sdk-info" v-for="(sdkItem,index) in sdkList" :key="index">
    <div class="label">{{ `${index+1}.${sdkItem.title}` }}</div>
    <div>
      <span class="label">包名信息：</span>
      <span class="value">{{ sdkItem.packageName }}</span>
    </div>
    <div>
      <span class="label">使用目的：</span>
      <span class="value">{{ sdkItem.purpose ? sdkItem.purpose : "无" }}</span>
    </div>
    <div>
      <span class="label">使用权限：</span>
      <span class="value" v-if="sdkItem.permissionsList && sdkItem.permissionsList.length">
        <div v-for="(permissions,permissionsIndex) in sdkItem.permissionsList" :key="`permissions${permissionsIndex}`">{{ permissions }}</div>
      </span>
      <span class="value" v-else>无</span>
    </div>
    <div>
      <span class="label">涉及个人信息：</span>
      <span class="value">{{ sdkItem.personalInfo ? sdkItem.personalInfo : "无" }}</span>
    </div>
    <div>
      <span class="label">隐私权政策链接/官网：</span>
      <a :href="sdkItem.link" style="display: block;">{{ sdkItem.link ? sdkItem.link : "无" }}</a>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      sdkList:[
        {
          title: "uni-app(5+、web2app)" ,
          packageName: "io.dcloud" ,
          purpose: "基础模块" ,
          permissionsList: [
            "android.permission.INTERNET",
            "android.permission.ACCESS_NETWORK_STATE",
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.READ_EXTERNAL_STORAG",
            "android.permission.READ_PHONE_STATE"
          ],
          personalInfo: "存储的个人文件，设备信息（IMEI、ANDROID_ID、DEVICE_ID、IMSI），网络信息",
          link: "https://ask.dcloud.net.cn/article/36937"
        },
        {
          title: "阿里weexSDK" ,
          packageName: "com.taobao" ,
          purpose: "uni-app基础模块默认集成，用于渲染uniapp的nvue页面引擎" ,
          permissionsList: [
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.READ_EXTERNAL_STORAG"
          ],
          personalInfo: "存储的个人文件",
          link: "https://weexapp.com/zh/"
        },
        {
          title: "Fresco图库" ,
          packageName: "com.facebook.fresco" ,
          purpose: "用于nvue页面加载图片使用" ,
          permissionsList: [
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.READ_EXTERNAL_STORAG"
          ],
          personalInfo: "存储的个人文件",
          link: "https://www.fresco-cn.org/"
        },
        {
          title: "glide图库" ,
          packageName: "com.bumptech.glide" ,
          purpose: "用于图片预览使用" ,
          permissionsList: [
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.READ_EXTERNAL_STORAG"
          ],
          personalInfo: "存储的个人文件",
          link: "http://bumptech.github.io/glide/"
        },
        {
          title: "gif-drawable" ,
          packageName: "pl.droidsonroids.gif" ,
          purpose: "加载gif图" ,
          permissionsList: [
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.READ_EXTERNAL_STORAG"
          ],
          personalInfo: "存储的个人文件",
          link: "https://github.com/koral--/android-gif-drawable"
        },
        {
          title: "fastjson" ,
          packageName: "com.alibaba.fastjson" ,
          purpose: "JSON解析" ,
          permissionsList: [],
          personalInfo: "",
          link: "https://github.com/alibaba/fastjson"
        },
        {
          title: "移动安全联盟 OAID" ,
          packageName: "com.bun.miitmdid、com.zui.opendeviceidlibrary、com.netease.nis、com.samsung.android、com.huawei.hms" ,
          purpose: "获取oaid" ,
          permissionsList: [],
          personalInfo: "设备信息",
          link: "http://www.msa-alliance.cn/col.jsp?id=122"
        },
        {
          title: "个推·消息推送" ,
          packageName: "com.igexin" ,
          purpose: "消息推送(请根据具体使用目的填写)" ,
          permissionsList: [
            "android.permission.ACCESS_NETWORK_STATE",
            "android.permission.ACCESS_WIFI_STATE",
            "android.permission.READ_PHONE_STATE",
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.VIBRATE",
            "android.permission.GET_TASKS",
            "android.permission.QUERY_ALL_PACKAGES"
          ],
          personalInfo: "存储的个人文件、设备信息（IMEI、MAC、ANDROID_ID、DEVICE_ID、IMSI）、应用已安装列表、网络信息",
          link: "http://docs.getui.com/privacy"
        },
        {
          title: "微信开放平台" ,
          packageName: "com.tencent.mm" ,
          purpose: "登录、分享、支付" ,
          permissionsList: [
            "android.permission.ACCESS_NETWORK_STATE",
            "android.permission.ACCESS_WIFI_STATE"
          ],
          personalInfo: "存储的个人文件、网络信息",
          link: "https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy"
        },
        {
          title: "支付宝开放平台" ,
          packageName: "com.alipay" ,
          purpose: "支付" ,
          permissionsList: [
            "android.permission.ACCESS_NETWORK_STATE",
            "android.permission.ACCESS_WIFI_STATE"
          ],
          personalInfo: "网络信息 设备id IP地址 OAID IMSI",
          link: "https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132"
        },
        {
          title: "高德开放平台" ,
          packageName: "com.amap.api, com.loc, com.autonavi" ,
          purpose: "实现定位以及展现地图" ,
          permissionsList: [
            "android.permission.ACCESS_COARSE_LOCATION",
            "android.permission.ACCESS_FINE_LOCATION",
            "android.permission.ACCESS_NETWORK_STATE",
            "android.permission.ACCESS_WIFI_STATE",
            "android.permission.CHANGE_WIFI_STATE",
            "android.permission.READ_PHONE_STATE",
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.ACCESS_LOCATION_EXTRA_COMMANDS"
          ],
          personalInfo: "存储的个人文件、位置信息、读取手机状态和身份、网络信息、传感器信息、Android ID",
          link: "https://lbs.amap.com/agreement/compliance"
        },
        {
          title: "百度开放平台" ,
          packageName: "com.baidu" ,
          purpose: "实现定位以及展现地图" ,
          permissionsList: [
            "android.permission.ACCESS_COARSE_LOCATION",
            "android.permission.ACCESS_FINE_LOCATION",
            "android.permission.ACCESS_NETWORK_STATE",
            "android.permission.ACCESS_WIFI_STATE",
            "android.permission.CHANGE_WIFI_STATE",
            "android.permission.READ_PHONE_STATE",
            "android.permission.WRITE_EXTERNAL_STORAGE",
            "android.permission.ACCESS_LOCATION_EXTRA_COMMANDS",
            "android.permission.READ_LOGS",
            "android.permission.WRITE_SETTINGS",
            "android.permission.MOUNT_UNMOUNT_FILESYSTEM"
          ],
          personalInfo: "存储的个人文件、位置信息、读取手机状态和身份、网络信息",
          link: "https://map.baidu.com/zt/client/privacy/index.html"
        },
        {
          title: "腾讯文字识别客户端" ,
          packageName: "com.tencent.cloud" ,
          purpose: "实现定位以及展现地图" ,
          permissionsList: [
            "android.permission.CAMERA"
          ],
          personalInfo: "需要识别的图片信息、设备型号、操作系统",
          link: "https://map.baidu.com/zt/client/privacy/index.html"
        },
        {
          title: "腾讯云慧眼人脸核身增强版" ,
          packageName: "com.tencent.cloud" ,
          purpose: "实人实名认证" ,
          permissionsList: [
            "android.permission.CAMERA",
            "android.permission.INTERNET",
            "android.permission.ACCESS_NETWORK_STATE",
            "android.permission.WRITE_EXTERNAL_STORAGE",
          ],
          personalInfo: "身份证信息（姓名、身份证号码）、人脸视频和照片、光线传感器信息、设备型号、操作系统、网络连接类型 、IP地址、系统设置、系统属性（含传感器列表信息）、相机（相机参数、接口）、OAID、部分存储文件路径",
          link: "https://privacy.qq.com/document/preview/f7370a2ac2224ec98be3d30609568ba3"
        },
        {
          title: "腾讯优图Faceln人脸核身" ,
          packageName: "com.tencent.cloud" ,
          purpose: "活体检测实现实人认证" ,
          permissionsList: [
            "android.permission.CAMERA",
            "android.permission.RECORD_AUDIO",
          ],
          personalInfo: "人脸视频及照片",
          link: "https://privacy.qq.com/document/preview/13a6cbc478814273a8584cce698b8e08"
        },
        {
          title: "腾讯图灵盾人脸防攻击" ,
          packageName: "com.tencent.cloud" ,
          purpose: "1.获取网络连接类型进行传输优化；2.获取IP地址用于网络传输，与SDK服务器建立通信；3.获取右列设备信息（网络连接类型除外）进行设备风险环境监测、恶意应用监测、ROM劫持攻击等安全监测与防护功能，用于识别是否为真实设备及真人使用本SDK，及时拦截刷脸过程中的作弊、劫持或攻击等黑产行为" ,
          permissionsList: [
            "android.permission.INTERNET",
            "android.permission.ACCESS_NETWORK_STATE",
            "android.permission.CAMERA",
            "android.permission.WRITE_EXTERNAL_STORAGE"
          ],
          personalInfo: "1.系统设置、系统属性（含传感器列表信息 ）、网络连接类型、设备型号、操作系统、IP地址、相机（相机参数、接口）2.不同系统版本还共享以下信息：Android：OAID、部分存储文件路径；",
          link: "https://privacy.qq.com/document/preview/b8f92d6cdc0d4dc3ab6192d7096cee68"
        },
        {
          title: "Bugly" ,
          packageName: "com.tencent.cloud" ,
          purpose: "对SDK运行时发生的故障问题进行排查，分析SDK和设备本身的异常和性能问题，定位和分析异常" ,
          permissionsList: [
            "android.permission.INTERNET",
            "android.permission.ACCESS_NETWORK_STATE",
          ],
          personalInfo: "手机型号、手机品牌、 Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否 root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和 PID",
          link: "https://privacy.qq.com/document/preview/b8f92d6cdc0d4dc3ab6192d7096cee68"
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .pages {
    padding: 0 12px 24px 12px;
  }
  .sdk-info + .sdk-info {
    margin-top: 32px;
  }
  .pages-title {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    color: #2A2A2A;
    line-height: 30px;
  }
  .label {
    font-weight: bold;
  }
  .label,.value {
    font-size: 14px;
    color: #3D3833;
    line-height: 22px;
  }
</style>